import { TUpsertMultipleTransactionsParams } from '@commenda/types/src/cap-table/types';
import { fetcher } from '@commenda/utils';

// Untill the user does not hit a final submit, one should have the ability to update the transactions
// a transaction can be edited till it actually gets submitted in a share certificate
export const upsertMultipleCapTableTransactions = async ({
  stockClassId,
  corporationIdToBuySharesIn,
  transactions,
}: TUpsertMultipleTransactionsParams) => {
  const res = await fetcher('capTable/transactions', {
    method: 'POST',
    body: {
      stockClassId,
      corporationIdToBuySharesIn,
      transactions,
    },
  });

  return res;
};
